export default function Greeting() {
  return (
    <section id="인사말" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/cae36c534e246693c7b79d8a9b4e97ac.jpg"
                alt="인사말"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-blue-100 rounded-full -z-10"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-orange-100 rounded-full -z-10"></div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-block bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              인사말
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6 leading-tight">
              <strong>유앤아이월드</strong>를<br />
              찾아주셔서 감사합니다
            </h2>
            <div className="space-y-6 text-gray-700 leading-relaxed text-lg">
              <p>
                안녕하십니까. 사단법인 유앤아이월드 <strong>임직원 일동</strong>입니다.
              </p>
              <p>
                저희 유앤아이월드는 <strong>나눔과 봉사</strong>를 실천하며, 우리 사회의 소외된 이웃들에게 
                희망과 사랑을 전하고자 설립되었습니다.
              </p>
              <p>
                <strong>교육지원, 의료지원, 생활지원</strong> 등 다양한 분야에서 활동하며, 
                특히 아동과 청소년, 독거노인, 저소득층 가정을 위한 실질적인 도움을 제공하고 있습니다.
              </p>
              <p>
                작은 나눔이 모여 큰 변화를 만들어냅니다. 여러분의 따뜻한 관심과 참여가 
                누군가에게는 <strong>내일을 살아갈 힘</strong>이 됩니다.
              </p>
              <p>
                앞으로도 유앤아이월드는 더 많은 이웃들과 함께 <strong>더 나은 세상</strong>을 
                만들어가겠습니다. 여러분의 동참을 기다립니다.
              </p>
              <p className="text-gray-900 font-semibold text-xl mt-8">
                감사합니다.
              </p>
              <div className="flex items-center gap-4 mt-8">
                <div className="text-right">
                  <p className="text-gray-900 font-bold text-xl">사단법인 유앤아이월드</p>
                  <p className="text-gray-600 text-lg mt-1">임직원 일동</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
